import { render, staticRenderFns } from "./AzTextViewEditDate.vue?vue&type=template&id=5f6281ae&"
import script from "./AzTextViewEditDate.vue?vue&type=script&lang=js&"
export * from "./AzTextViewEditDate.vue?vue&type=script&lang=js&"
import style0 from "./AzTextViewEditDate.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
